import type { QueryClient } from '@tanstack/react-query';

import { notificationKey } from './queryKeys';

export const invalidateNotificationByUser = (qc: QueryClient, userId: string) =>
    qc.invalidateQueries({
        queryKey: notificationKey.byUser(userId),
        exact: false,
    });
